import React from 'react';

import classnames from 'classnames';

import wave from 'assets/images/homepage/wave.png';
import successImage from 'assets/images/img_thanks.jpg';

import Image from 'shared/components/Image';
import Button from 'shared/components/Button';
import PopOverModal from 'shared/components/Modals/PopOverModal';

import { BookATourForm } from 'pages/Home/components';

import styles from './styles.module.scss';

const BookATourModal = ({ closeModal, submissionSuccessActions }) => (
  <PopOverModal
    className={styles.modal}
    closeModal={closeModal}
    withoutHeaderBorder={true}
    modalCloseIconClassName={styles.modalClose}
    headline={
      <div className={styles.headline}>Book a tour with the Unissu team</div>
    }>
    <BookATourForm
      submitButtonText="Submit"
      submissionSuccessActions={submissionSuccessActions}
    />
  </PopOverModal>
);

const BookSubmissionSuccessModal = ({ closeModal }) => (
  <PopOverModal
    className={styles.successModal}
    closeModal={closeModal}
    withoutHeaderBorder={true}
    modalCloseIconClassName={styles.modalClose}>
    <div className={styles.container}>
      <Image height="175" width="263" src={successImage} />
      <div className={styles.title}>Thanks for booking a tour!</div>
      <div className={styles.description}>
        A member of our team will contact you shortly
      </div>
      <Button className={styles.button} color="primary" onClick={closeModal}>
        Thanks!
      </Button>
    </div>
  </PopOverModal>
);

class BookATourModalTrigger extends React.Component {
  state = {
    isModalOpen: false,
    isSubmissionSuccessModalOpen: false
  };

  toggleModal = () =>
    this.setState(prevState => ({
      isModalOpen: !prevState.isModalOpen
    }));

  toggleSuccessModal = () =>
    this.setState(prevState => ({
      isSubmissionSuccessModalOpen: !prevState.isSubmissionSuccessModalOpen
    }));

  render() {
    const { isModalOpen, isSubmissionSuccessModalOpen } = this.state;

    const { className } = this.props;

    return (
      <div className={classnames(styles.wrapper, className)}>
        <div className={styles.decoration}>
          <Image src={wave} height="279" width="100%" />
        </div>
        <div className={styles.container}>
          <div className={styles.title}>I’d like to book a tour of Unissu</div>
          <Button
            className={styles.button}
            color="primary"
            onClick={this.toggleModal}>
            I want a tour!
          </Button>
        </div>
        {isModalOpen && (
          <BookATourModal
            closeModal={this.toggleModal}
            submissionSuccessActions={[
              this.toggleModal,
              this.toggleSuccessModal
            ]}
          />
        )}
        {isSubmissionSuccessModalOpen && (
          <BookSubmissionSuccessModal closeModal={this.toggleSuccessModal} />
        )}
      </div>
    );
  }
}

export default BookATourModalTrigger;
